<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
  import {ref, reactive, watch} from 'vue';

  export default {
    name: 'App',
    data() {
      return {
        isMobile: false,
        screenWidth:0,
      }
    },
    methods:{
      updateWindowWidth() {
        //查看版本：电脑和手机
        const userAgent=navigator.userAgent.toLowerCase();
        console.log(userAgent);
        //判断屏幕宽度
        this.screenWidth= window.innerWidth;
        if (this.screenWidth<= 758) {
          console.log('移动端');
          this.$router.push({path: '/MobileHomePage'});
        } else {
          console.log('电脑端');
          //catch捕捉错误
          this.$router.push({path: '/PcHomePage'}).catch(() => {
          });
        }
      }
    },
    mounted() {
      this.updateWindowWidth();
      window.addEventListener('resize', this.updateWindowWidth);
      // 在页面加载时读取sessionStorage
      if (sessionStorage.getItem('store')) {
        this.$store.replaceState(Object.assign(), this.$store.state, JSON.parse(sessionStorage.getItem('store')));
      }
      //在页面刷新时将store保存到sessionStorage里
      window.addEventListener('beforeunload', () => {
        sessionStorage.setItem('store', JSON.stringify(this.$store.state));
      })
    },
    destroyed(){
      window.removeEventListener('resize', this.updateWindowWidth);
    }
  }
</script>

<style>
  #app {
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    text-align: center;
    color: #2c3e50;
    height: 100%;
    margin: 0px;
    padding: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue